export const translations = {
    el: {
        openMap: 'Άνοιγμα χάρτη',
        closeMap: '✖',
        accessibilityLayers: 'Επίπεδα Προσβασιμότητας',
        visitWebsite: 'Επισκεφθείτε την ιστοσελίδα',
        layers: {
            paths: 'Μονοπάτια',
            elevators: 'Ανελκυστήρες',
            ramps: 'Ράμπες',
            parking: 'Στάθμευση',
            entrances: 'Είσοδοι',
            wc: 'Τουαλέτες WC'
        },
        dock: {
            voutes: 'Βούτες',
            voutesFull: 'Βούτες (Ηράκλειο)',
            gallos: 'Γάλλος',
            gallosFull: 'Γάλλος (Ρέθυμνο)',
            otherLocs: 'Άλλες Τοποθεσίες',
            eduMuseum: 'Μουσείο Εκπ/σης',
            eduMuseumFull: 'Μουσείο της Εκπαίδευσης',
            cultureHouse: 'Σπίτι Πολιτισμού',
            cultureHouseFull: 'Σπίτι του Πολιτισμού',
            eleutherna: 'Αρχαία Ελεύθερνα',
            eleuthernaFull: 'Αρχαία Ελεύθερνα',
            skinakas: 'Σκίνακας',
            skinakasFull: 'Αστεροσκοπείο Σκίνακα',
            nhmc: 'Μουσείο Φυσ. Ιστορίας',
            nhmcFull: 'Μουσείο Φυσικής Ιστορίας',
            finokalias: 'Φινοκαλιάς',
            finokaliasFull: 'Σταθμός Φινοκαλιά',
            langLabel: 'EN'
        },
        timeline: {
            title: 'Ιστορικό (Timeline)'
        },
        // Fallback labels for hotspots that carry no title of their own -- see
        // modules/hotspotTooltips.js. Keyed by Pano2VR Skin-ID.
        //
        // ht_info_parking is deliberately absent. There are 23 of them, more than any other
        // kind, and a label reading "Στάθμευση" over and over as the view turns is noise rather
        // than information. Naming an individual parking area in Pano2VR still labels it -- a
        // real title always beats the kind.
        hotspotKinds: {
            ht_uoc_lib: 'Βιβλιοθήκη',
            ht_info_bus: 'Στάση λεωφορείου',
            ht_uoc_restarant: 'Εστιατόριο',
            ht_uoc: 'Πανεπιστήμιο Κρήτης'
        }
    },
    en: {
        openMap: 'Open Map',
        closeMap: '✖',
        accessibilityLayers: 'Accessibility Layers',
        visitWebsite: 'Visit website',
        layers: {
            paths: 'Paths',
            elevators: 'Elevators',
            ramps: 'Ramps',
            parking: 'Parking',
            entrances: 'Entrances',
            wc: 'WC'
        },
        dock: {
            voutes: 'Voutes',
            voutesFull: 'Voutes (Heraklion)',
            gallos: 'Gallos',
            gallosFull: 'Gallos (Rethymno)',
            otherLocs: 'Other Locations',
            eduMuseum: 'Edu Museum',
            eduMuseumFull: 'Museum of Education',
            cultureHouse: 'Culture House',
            cultureHouseFull: 'House of Culture',
            eleutherna: 'Ancient Eleutherna',
            eleuthernaFull: 'Ancient Eleutherna',
            skinakas: 'Skinakas',
            skinakasFull: 'Skinakas Observatory',
            nhmc: 'Natural History Museum',
            nhmcFull: 'Natural History Museum of Crete',
            finokalias: 'Finokalias',
            finokaliasFull: 'Finokalias Station',
            langLabel: 'GR'
        },
        timeline: {
            title: 'Timeline (History)'
        },
        hotspotKinds: {
            ht_uoc_lib: 'Library',
            ht_info_bus: 'Bus stop',
            ht_uoc_restarant: 'Restaurant',
            ht_uoc: 'University of Crete'
        }
    }
};

export function getLangFromURL(defaultLang = 'el') {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang') || params.get('language') || params.get('hl');
    return lang && translations[lang] ? lang : defaultLang;
}